export class DataTableConstant {
  defaultCSSClasses = {
    sortAscending: 'mdi mdi-sort-reverse-variant',
    sortDescending: 'mdi mdi-sort-variant'
  };
}
